import styled from "styled-components";

export const CustomLabel = styled.label`
  width: 100%;
  font-family: "Nunito";
  font-size: ${({ fontSize }) => fontSize || "12px"};
  font-weight: 500;
  margin-bottom: 0px;
`;
